/* eslint-disable react-hooks/exhaustive-deps */

import { BigNumber, constants } from 'ethers';

import config from '../../constants/baseConfig';
import useApproveAnyErc20ContractCall from './useApproveAnyErc20ContractCall';

const useApproveErc20ContractCall = (
  spenderAddress?: string,
  amount: BigNumber = constants.MaxUint256,
  onSuccess?: () => void
) =>
  useApproveAnyErc20ContractCall(
    config.contracts.erc20Contract.address,
    spenderAddress,
    amount,
    onSuccess
  );

export default useApproveErc20ContractCall;
